// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract, { FlatBody } from "./ArticleAbstract";

const Wrapper = styled.div`
  padding: 43px 0 25px 0;
  float: left;
  width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 43, 35, "vw")} 25px 25px 25px;
    width: calc(100% - 50px);
    justify-content: space-between;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    padding: 0;
    margin: 40px 23px 15px 23px;
    flex-direction: column;
    align-items: center;
  }
`;

class SetLandscape extends Component {
  render() {
    return (
      <Wrapper>
        {this.props.set.map(item => <Landscape content={item} />)}
      </Wrapper>
    );
  }
}

export default SetLandscape;

const Item = styled.div`
  width: 500px;
  padding: 20px;
  float: left;
  @media (max-width: 1100px) {
    padding: 0;
    width: ${scale(1100, 767, 505, 349, "vw")};
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 15px 0;
  }
`;
const Image = styled.div`
  width: 500px;
  height: 280px;
  float: left;

  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: 1100px) {
    width: 100%;
    height: 0;
    padding-top: 56%;
  }
`;
const Article = styled.div`
  width: calc(100% - 60px);
  padding: 30px;
  float: left;
  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 30, 10, "vw")};
    width: 80%;
    flex-grow: 1;
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 15px 0 0 0;
  }
`;
const Title = styled.div`
  width: 100%;
  float: left;
  font-family: Lato;
  font-size: 25px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.32;
  letter-spacing: 0.4px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    line-height: ${scale(1100, 767, 25 * 2.32, 18, "vw")};
    font-size: ${scale(1100, 767, 25, 18, "vw")};
    letter-spacing: 0.3px;
  }
  @media (max-width: 700px) {
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.3px;
    text-align: center;
    padding: 0 0 10px 0;
  }
`;
const Body = styled.div`
  width: 100%;
  float: left;
  padding-top: 11px;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: 1px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    padding-top: ${scale(1100, 767, 11, 8, "vw")};

    font-size: ${scale(1100, 767, 14, 13, "vw")};
    line-height: ${scale(1100, 767, 14 * 1.64, 13 * 1.77, "vw")};

    letter-spacing: 0.9px;
  }
  @media (max-width: 700px) {
    font-size: 12px;
    line-height: 1.67;
    letter-spacing: 0.8px;
    text-align: center;
  }
`;

class Landscape extends ArticleAbstract {
  // image
  // title
  // body
  render() {
    return (
      <Item {...this.link()}>
        <Image style={this.image()} />
        <Article>
          <Title>{this.title()}</Title>
          <Body>
            <FlatBody>{this.body()}</FlatBody>
          </Body>
        </Article>
      </Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetLandscape.js